import { Client } from '@foundation-player/runtime';
import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Advertising Plugin.
 *
 * @remarks
 * The plugin is enabled by default for all clients.
 * The only exceptions are if explicitly disabled or if the client is not monetized via video ads, which are:
 * - RTL Plus Podcast: The ads are embedded into the MP3 streams and audio only.
 * - Media Hub: The app is not monetized at all.
 */
export const addAdvertisingPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs, clientAndScope) => {
  const advertising = 'foundation.plugin.advertising';

  if (pluginConfigs[advertising]?.enabled === false) {
    return pluginConfigs;
  }

  const excludedClients: Array<Client | undefined> = [Client.RTLPlusPodcast, Client.MediaHub];
  if (!pluginConfigs[advertising]?.enabled && excludedClients.includes(clientAndScope?.client)) {
    return pluginConfigs;
  }

  return {
    ...pluginConfigs,
    [advertising]: {
      ...pluginConfigs[advertising],
      enabled: true,
    },
  };
};
